import { render } from "./P3PDiagramEditor.vue?vue&type=template&id=2360940b"
import script from "./P3PDiagramEditor.vue?vue&type=script&lang=js"
export * from "./P3PDiagramEditor.vue?vue&type=script&lang=js"

import "./P3PDiagramEditor.vue?vue&type=style&index=0&id=2360940b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__